import { render, staticRenderFns } from "./printtreatment.vue?vue&type=template&id=447c20d8"
import script from "./printtreatment.vue?vue&type=script&lang=js"
export * from "./printtreatment.vue?vue&type=script&lang=js"
import style0 from "./printtreatment.vue?vue&type=style&index=0&id=447c20d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports